import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class AppSettingService {
  private settings: Record<string, string> = {};

  constructor(private http: HttpClient) {}

  load(): Promise<void> {
    return firstValueFrom(
      this.http.get<Record<string, string>>(environment.apiUrl + '/api/app-settings')
    ).then(data => { this.settings = data ?? {}; }).catch(() => {});
  }

  get timezone(): string {
    return 'America/New_York';
  }

  getSetting(key: string): string | undefined {
    return this.settings[key];
  }
}
